// extracted by mini-css-extract-plugin
module.exports = {"profilePictureWrapper":"styles_profilePictureWrapper__3rRaX","profilePicture":"styles_profilePicture__HtfrS","editProfile":"styles_editProfile__3-ZFx"};